//import {Network} from '@ionic-native/network';
import {Injectable} from '@angular/core';
import {AlertProvider} from '../alert/alert'

@Injectable()
export class NetworkProvider {

    constructor(
        //public network: Network,
        public alert: AlertProvider
    ) {
        console.log('Hello NetworkProvider Provider');
    }

    check() {
        // if (this.network.type == 'none') {
        //     this.alert.show('Network error!', '', [], [], 'network_error');
        // }
    }

}



// WEBPACK FOOTER //
// ./src/providers/network/network.ts